module.exports = __webpack_public_path__ + "img/ELABORACION-BACK.95f219e9.png";